import styled from "styled-components";

import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";

import Info from "core/ReusableIcons/Info";

export const Wrapper = styled.div`
    display: flex;
    gap: ${convertPxToRem(6)};
    align-items: center;
`;

export const ToolTipIcon = styled(Info).attrs({
    fillColor: colors.accent.lightMode.persian,
    size: { height: 18, width: 18 }
})`
    margin-top: 2px;
    cursor: pointer;
`;
